import SignIn from "@/components/auth/SignIn";
import { SignInFlowType } from "@/components/auth/SignInFlowTypes";
import React from "react";

const Signup: React.FC = () => {
  return (
    <div className="flex w-full items-center justify-center">
      <SignIn flowType={SignInFlowType.SIGN_UP} />
    </div>
  );
};

export default Signup;
